import { ReactNode } from "react";
import styled from "styled-components";

const ChatFooterMenu = (): ReactNode => {
  return (
    <StyledChatFooterMenu>
      <i className="feather-menu" />
    </StyledChatFooterMenu>
  );
};

const StyledChatFooterMenu = styled.div`
  flex: none;
  width: 45px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  .feather-menu {
    color: #6b7385;
    font-size: 22px;
  }

  :hover {
    cursor: pointer;
    color: #000;
  }
`;

export default ChatFooterMenu;
